import { render } from "./MenuItemsSwiper.vue?vue&type=template&id=fe5ea6ba&scoped=true"
import script from "./MenuItemsSwiper.vue?vue&type=script&lang=js"
export * from "./MenuItemsSwiper.vue?vue&type=script&lang=js"

import "./MenuItemsSwiper.vue?vue&type=style&index=0&id=fe5ea6ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe5ea6ba"]])

export default __exports__